import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { Avatar } from "primereact/avatar";
import { AvatarGroup } from "primereact/avatargroup";

export default function AvatarGroupComponent({
  count = 0,
  size = "large",
  avatars,
  shape = "circle",
}) {
  // Show only first 3 avatars
  const maxAvatars = 3;
  const avatarsToShow = avatars?.slice(0, maxAvatars) || [];
  const hiddenAvatarsCount = count - maxAvatars;
  return (
    <div>
      <AvatarGroup>
        {avatarsToShow.map((item) => (
          <Avatar
            key={item?.user_id}
            image={
              item?.profile_picture
                ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(item?.user_id)}`
                : null
            }
            size={size}
            shape={shape}
          />
        ))}
        {hiddenAvatarsCount > 0 && (
          <Avatar
            label={`+${hiddenAvatarsCount}`}
            shape={shape}
            className="text-secondaryTextColor text-15px public_sans_400"
            size={size}
          />
        )}
        {
          count === 0 && (
            <Avatar
              label={`${count}`}
              shape={shape}
              className="text-secondaryTextColor text-15px public_sans_400"
              size={size}
            />
          )
        }

      </AvatarGroup>
    </div>
  );
}
